import * as React from "react"

function SvgChevronLeft(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 27"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M14.401 25.541a.496.496 0 01-.331-.125L1.495 14.235a1.01 1.01 0 01-.001-1.503L14.069 1.55a.5.5 0 01.707.044.505.505 0 01-.043.709L2.157 13.483l12.575 11.18a.505.505 0 01-.331.878z"
      />
    </svg>
  )
}

export default SvgChevronLeft
